import { HOLES_CHOICES } from '../../player/events/store';
import { ICourse, ITee } from '../courses/store';
import { IEventEnrollment } from '../eventEnrollments/store';

export interface IRoundGame {
  adjustedHandicap: number;
  enrollment: number;
  grossScore: number;
  group: number;
  handicap: number;
  id: number;
  index: number;
  netScore: number;
  qualified: boolean;
  round: number;
  seat: number;
  tee: number;
}

export interface IRoundGroup {
  games: IRoundGame[];
  id: number;
  round: number;
  scorer?: number;
  start: string;
  startingHole?: number;
  startingPosition?: string;
}

export interface ITeeAssignment {
  flight: number;
  id: number;
  round: number;
  tee: ITee;
}

export interface IBaseEventRound {
  course: ICourse;
  event: number;
  holes: HOLES_CHOICES;
  id: number;
  order: number;
  playersPerTee: number;
  shotgunStart: boolean;
  start: string;
  teeFrequency: string;
}

export interface IEventRound extends IBaseEventRound {
  enrollments?: IEventEnrollment[];
  groups?: IRoundGroup[];
  status?: string;
  teeAssignments: ITeeAssignment[];
  totalPlayers?: number;
  handicapAllowance: number;
}

export interface IEventDetailedRound extends IEventRound {
  groups: IRoundGroup[];
  totalPlayers: number;
  enrollments: IEventEnrollment[];
  teeAssignments: ITeeAssignment[];
}

export interface IAdminEventRoundsStore {
  [roundId: number]: IEventDetailedRound;
  current?: IEventDetailedRound;
}

export const adminEventRoundsStore: IAdminEventRoundsStore = {};
